module.exports = __webpack_public_path__ + "img/Edificios desactivado.9ee13536.svg";